export default "__VITE_ASSET__$qBHj5ZJ__"